<div class="m-15">
  <div class="pages-header">
    <h1 class="mobile-move-title">Setup & Settings</h1>
  </div>
  <div class="default-workspaces-ch-panels flex-grow">
    <div class="ch-panel">
      <div class="menu">
        <div class="category-label">
          <i class="tio-group_equal"></i>
          Client Setup
        </div>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/initial-folders"
          routerLinkActive="active"
        >
          Initial Folders
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/client-fields"
          routerLinkActive="active"
        >
          Client Fields
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/contact-fields"
          routerLinkActive="active"
        >
          Contact Fields
        </a>
      </div>
      <div class="menu">
        <div class="category-label">
          <i class="tio-user_add"></i>
          Add Clients
        </div>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/adding-clients"
          routerLinkActive="active"
        >
          Adding Clients
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/import-clients"
          routerLinkActive="active"
        >
          Import Clients
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/import-contacts"
          routerLinkActive="active"
        >
          Import Contacts
        </a>
      </div>
      <div class="menu">
        <div class="category-label">
          <i class="tio-settings_outlined"></i>
          Manage Workflow
        </div>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/adding-jobs"
          routerLinkActive="active"
        >
          Adding Jobs
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/connect-email"
          routerLinkActive="active"
        >
          Connect Email
        </a>
      </div>
      <div class="menu">
        <div class="category-label">
          <i class="tio-layout"></i>
          Client Portal
        </div>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/client-portal-design"
          routerLinkActive="active"
        >
          Design
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/invite-message"
          routerLinkActive="active"
        >
          Invite Message
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/links"
          routerLinkActive="active"
        >
          Initial Links
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/initial-client-task"
          routerLinkActive="active"
        >
          Initial Client Task
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/invite-clients"
          routerLinkActive="active"
        >
          Invite Clients
        </a>
      </div>
      <div class="menu">
        <div class="category-label">
          <i class="tio-plugin"></i>
          Advanced
        </div>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/quickbooks-integration"
          routerLinkActive="active"
        >
          QuickBooks integration
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/xero-integration"
          routerLinkActive="active"
        >
          Xero integration
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/anchor"
          routerLinkActive="active"
        >
          Premium Integrations
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/tags-library"
          routerLinkActive="active"
        >
          Tags Library
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/apps-library"
          routerLinkActive="active"
        >
          Apps Library
        </a>
        <a
          class="menu-item"
          routerLink="/practice/setup-and-settings/resources-library"
          routerLinkActive="active"
        >
          Resources Library
        </a>
      </div>
    </div>
    <div class="ch-panel-content d-flex flex-column flex-grow">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
